import React, { HTMLAttributes } from 'react';
import { Typography, LinkButton } from 'fronton-react';
import clsx from 'clsx';
import { primaryMenuItem, linkSpace, stretchedLink } from './styles';

export interface PrimaryMenuItemProps extends HTMLAttributes<HTMLElement> {
  title: string;
  subtitle: string;
  href: string;
}

export const PrimaryMenuItem = (props: PrimaryMenuItemProps) => {
  const { title, subtitle, href, className, ...rest } = props;

  return (
    <LinkButton {...rest} as="a" href={href} className={clsx(primaryMenuItem, stretchedLink, className)}>
      <div className={linkSpace}>
        <Typography as="div" color="text-primary" variant="h3">
          {title}
        </Typography>
        <Typography variant="caption" color="text-primary">
          {subtitle}
        </Typography>
      </div>
    </LinkButton>
  );
};
